import { serviceApi } from '~/features';
import { clearParams } from '~/shared';

export async function downloadActiveCampaignsExport(params = {}) {
  const clearedParams = clearParams(params);
  const response = await serviceApi.get<Blob>(
    `Campanha/ActiveCampaigns-Export?ProjectAdsId=1`,
    {
      responseType: 'blob',
      params: clearedParams,
    }
  );
  return response;
}
